/* JS enabled */
document.documentElement.classList.replace('no-js', 'js');

if (window.Shopify && Shopify.designMode) {
  document.documentElement.classList.add('shopify-design-mode');
}

/* Back to top */
window.scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

/* Attach button handler safely */
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('back-to-up');
  if (btn) btn.addEventListener('click', window.scrollToTop);
});

/* Scroll tracking (passive) */
let scrollTracked = false;
window.addEventListener(
  'scroll',
  () => {
    if (
      !scrollTracked &&
      window.scrollY + window.innerHeight >=
        document.body.offsetHeight * 0.75
    ) {
      scrollTracked = true;
      // analytics hook here
    }
  },
  { passive: true }
);
